import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Input } from 'antd';
import searchArray from '../searchArray';

const ItemsTable = ({ data }) => {
  const columns = [
    {
      key: 'materialSpecs',
      title: 'Material Specification',
      dataIndex: 'materialSpecification',
      align: 'center',
    },
    {
      key: 'quantity',
      title: 'Total Purchased Quantity',
      dataIndex: 'totalQtyBought',
      align: 'center',
    },
  ];
  const [search, setSearch] = useState('');
  const filtered = searchArray(search, data, ['materialSpecification']);

  return (
    <div>
      <Input.Search
        style={{
          width: '60%',
          minWidth: 400,
          margin: '10px 0 10px 0',
        }}
        placeholder="Search item"
        onChange={(e) => setSearch(e.target.value)}
      />
      <Table
        dataSource={filtered}
        size="middle"
        pagination={false}
        rowKey="materialSpecification"
        columns={columns}
        style={{
          overflowX: 'auto',
          overFlowY: 'auto',
          maxHeight: 500,
        }}
        bordered
      />
    </div>
  )
}
ItemsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
}
export default ItemsTable
